import React, { useContext, useEffect, useState } from "react";
import { organizationDetail } from "../../../Context/SelectedOrganization";
import axiosClient from "../../../Services/Axios/axios";
import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
const QuickSentInvitation = () => {
  const { organizationData } = useContext(organizationDetail);
  const qrRef = useRef();
  const [invitaionData, setInvitaionData] = useState({});
  const [copyStatus, setCopyStatus] = useState({
    link: false,
    code: false,
    qr: false,
  });

  const getInvitaionData = async () => {
    const response = await axiosClient.post(
      `employees/${process.env.REACT_APP_API_VERSION}/employee-invite-link`,
      {
        organization_id: sessionStorage.getItem("organization_id"),
      }
    );
    setInvitaionData(response.data.data);
  };

  useEffect(() => {
    getInvitaionData();
  }, [organizationData]);

  const handleDownloadQR = () => {
    const canvas = qrRef.current.querySelector("canvas");

    if (!canvas) return;

    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = "invite-qr.png";
    link.click();
  };

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);

    setCopyStatus((prev) => ({ ...prev, [type]: true }));

    setTimeout(() => {
      setCopyStatus((prev) => ({ ...prev, [type]: false }));
    }, 2000);
  };

  return (
    <div className="form_boxx profilss p-4">
      {/* Invite Link */}
      <div className="invite-card">
        <div>
          <h6>Invite Link</h6>
          <p>Share this link with members so they can join the organization.</p>
        </div>
        <button
          className="invite-btns"
          onClick={() => handleCopy(invitaionData?.invite_link, "link")}
        >
          {copyStatus.link ? "Copied!" : "Copy"}
        </button>
      </div>

      {/* Invite Code */}
      <div className="invite-card mt-3">
        <div>
          <h6>Invite Code</h6>
          <p>Members can enter this invite code to join.</p>
        </div>
        <button
          className="invite-btns"
          onClick={() => handleCopy(invitaionData?.invite_link, "code")}
        >
          {copyStatus.code ? "Copied!" : "Copy"}
        </button>
      </div>

      {/* QR Code */}
      {/* QR Code */}
      <div className="invite-card mt-3">
        <div>
          <h6>Invite QR Code</h6>
          <p>
            Share the QR code. Members can scan it to join the organization.
          </p>
        </div>

        <div className="d-flex align-items-center gap-2">
          {/* QR Image */}
          <div style={{ background: "#fff", padding: "10px" }} ref={qrRef}>
            <QRCodeCanvas value={invitaionData?.invite_link || ""} size={150} />
          </div>

          <div>
            {/* Copy QR (copy link) */}
            {/* <button
              className="invite-btns"
              onClick={() => handleCopy(invitaionData?.invite_link, "qr")}
            >
              {copyStatus.qr ? "Copied!" : "Copy"}
            </button> */}

            {/* Save QR Image */}
            <button className="invite-btns ml-2" onClick={handleDownloadQR}>
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickSentInvitation;
